import React, { useEffect, useRef, useState } from "react";
import * as styles from "./PortfolioSlider.module.scss"
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { ArrowLeft, ArrowRight } from "lucide-react";

const FilterSectionSlider = ({ title, overviewText, projects, mainTitle, projectText }) => {
    const [selectedCategory, setSelectedCategory] = useState("All");
    const [canScrollLeft, setCanScrollLeft] = useState(false);
    const [canScrollRight, setCanScrollRight] = useState(false);
    const cardContainerRef = useRef(null);

   
    const filteredProjects =
        selectedCategory === "All"
            ? projects
            : projects.filter((project) => project.category === selectedCategory);

    const updateScrollButtons = () => {
        const container = cardContainerRef.current;
        if (container) {
            setCanScrollLeft(container.scrollLeft > 0);
            setCanScrollRight(
                container.scrollLeft + container.offsetWidth < container.scrollWidth
            );
        }
    };

    const scroll = (direction) => {
        const container = cardContainerRef.current;
        if (container) {
            const scrollAmount = container.offsetWidth;
            container.scrollBy({
                left: direction === "left" ? -scrollAmount : scrollAmount,
                behavior: "smooth",
            });
        }
    };

    useEffect(() => {
        const container = cardContainerRef.current;
        const handleScroll = () => updateScrollButtons();

        if (container) {
            container.addEventListener("scroll", handleScroll);
            window.addEventListener("resize", updateScrollButtons);
            setTimeout(updateScrollButtons, 100);
        }

        return () => {
            if (container) container.removeEventListener("scroll", handleScroll);
            window.removeEventListener("resize", updateScrollButtons);
        };
    }, [filteredProjects]);

  
    const uniqueCategories = Array.from(new Set(projects.map((p) => p.category)));
    const categories = ["All", ...uniqueCategories];

    return (
        <section className={` container  c-padding ${styles.filterSection} `}>
            <h1 className={`h2 ${styles.head}`}>{mainTitle}</h1>
            <div>
                <div className={styles.contentWrapper}>
                    <div className={styles.overview}>
                        <div className={styles.containerBar}>
                            <p>{title}</p>
                        </div>
                        <div className={styles.paragraphText}>
                            <p>{overviewText?.overviewText}</p>
                        </div>
                    </div>

                    
                    <div className={styles.projects}>
                        <div className={styles.filterBar}>
                            <h2 className={styles.filterHeading}>{projectText}</h2>
                            <ul className={styles.categoryButtons}>
                               
                            </ul>
                           
                            <div className={styles.categoryDropdown}>
                                
                            </div>
                        </div>

                        <div className={styles.cardsWrapper}>
                            

                            <div className={styles.cards} ref={cardContainerRef}>
                                {filteredProjects.map((project, idx) => (
                                    <div key={idx} className={styles.card}>
                                        <div className={styles.imageBox}>
                                            <GatsbyImage image={getImage(project.image)} alt={project.title}
                                            loading="lazy"
                                            />
                                        </div>
                                        <h3>{project.title}</h3>
                                        <p className={` global-spacing-top ${styles.description} `}>
                                            {project.overviewText?.overviewText}
                                        </p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FilterSectionSlider;
